import "./index.scss";
import React from "react";
// import PropTypes from 'prop-types';
import { playAudio } from "../nonUIFuncs/index";

const Welcome = (props) => {
  return (
    <div className="current-screen-style">
      <div className="welcome-container">
        <div
          className={
            props.dims.width < 800
              ? "welcome-topContainerVertical"
              : "welcome-topContainer"
          }
        >
          <div className="welcome-containerContentsLang">
            <div className="welcome-top-message-container">
              {props.clientConfig.langArray.map((datum) => {
                return (
                  <div
                    key={datum.text}
                    className="welcome-message-lang"
                    onClick={() => playAudio(datum.audio)}
                  >
                    {datum.text}
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className={
              props.dims.width < 800
                ? "welcome-containerContentsEngVertical"
                : "welcome-containerContentsEng"
            }
          >
            <div className="welcome-top-message-container">
              {props.clientConfig.engArray.map((datum) => {
                return (
                  <div key={datum} className="welcome-message">
                    {datum}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="welcome-logo-container">
          {props.clientConfig.logoArray.map((sty) => {
            return <div key={sty} className={sty} />;
          })}
        </div>
        {props.clientConfig.messageArray.map((msg, idx) => {
          return <div key={idx} className="welcome-messageLower">{msg}</div>;
        })}
      </div>
    </div>
  );
};

export default Welcome;

Welcome.propTypes = {};
